import type { ColTypeDef } from 'ag-grid-community';
import { agMultiColumnFilter } from 'components/shared/Blotter/Grid/Hooks/utils';
import { useMemo } from 'react';

import { UnderlyingsCellRenderer } from '../CellRenderers';

export function useClientSideUnderlyingColumnType<T>(handleValuesUpdate: boolean = false): ColTypeDef<T> {
  return useMemo(
    () => ({
      cellRenderer: UnderlyingsCellRenderer,
      ...agMultiColumnFilter(handleValuesUpdate),
    }),
    [handleValuesUpdate],
  );
}

export function useServerSideUnderlyingColumnType<T>(): ColTypeDef<T> {
  return useMemo(
    () => ({
      cellRenderer: UnderlyingsCellRenderer,
      filterParams: {
        buttons: ['apply', 'cancel'],
      },
    }),
    [],
  );
}
